export type ElementTypes = 'nonmetal' | 'metal' | 'metalloid' | 'alkali' | 'noble' | 'hydrogen' | 'halogen';
type Element = {
  type: ElementTypes;
  y: number;
  x: number;
  name: string;
};
export type Elements = {
  [key: string]: Element;
};

export const elements: Elements = {
  C: {
    type: 'nonmetal',
    y: 2,
    x: 14,
    name: 'Carbon',
  },
  O: {
    type: 'nonmetal',
    y: 2,
    x: 16,
    name: 'Oxygen',
  },
  Es: {
    type: 'metal',
    y: 10,
    x: 13,
    name: 'Einsteinium',
  },
  Sb: {
    type: 'metalloid',
    y: 5,
    x: 15,
    name: 'Antimony',
  },
  Mo: {
    type: 'metal',
    y: 5,
    x: 6,
    name: 'Molybdenum',
  },
  Y: {
    type: 'metal',
    y: 5,
    x: 3,
    name: 'Yttrium',
  },
  Sg: {
    type: 'metal',
    y: 7,
    x: 6,
    name: 'Seaborgium',
  },
  Ca: {
    type: 'alkali',
    y: 4,
    x: 2,
    name: 'Calcium',
  },
  No: {
    type: 'metal',
    y: 10,
    x: 16,
    name: 'Nobelium',
  },
  Hf: {
    type: 'metal',
    y: 6,
    x: 4,
    name: 'Hafnium',
  },
  Md: {
    type: 'metal',
    y: 10,
    x: 15,
    name: 'Mendelevium',
  },
  Cu: {
    type: 'metal',
    y: 4,
    x: 11,
    name: 'Copper',
  },
  Al: {
    type: 'metal',
    y: 3,
    x: 13,
    name: 'Aluminum',
  },
  He: {
    type: 'noble',
    y: 1,
    x: 18,
    name: 'Helium',
  },
  Am: {
    type: 'metal',
    y: 10,
    x: 9,
    name: 'Americium',
  },
  Rf: {
    type: 'metal',
    y: 7,
    x: 4,
    name: 'Rutherfordium',
  },
  Sn: {
    type: 'metal',
    y: 5,
    x: 14,
    name: 'Tin',
  },
  Zn: {
    type: 'metal',
    y: 4,
    x: 12,
    name: 'Zinc',
  },
  Pr: {
    type: 'metal',
    y: 9,
    x: 5,
    name: 'Praseodymium',
  },
  Bk: {
    type: 'metal',
    y: 10,
    x: 11,
    name: 'Berkelium',
  },
  Pa: {
    type: 'metal',
    y: 10,
    x: 5,
    name: 'Protactinium',
  },
  Rh: {
    type: 'metal',
    y: 5,
    x: 9,
    name: 'Rhodium',
  },
  Ho: {
    type: 'metal',
    y: 9,
    x: 13,
    name: 'Holmium',
  },
  Gd: {
    type: 'metal',
    y: 9,
    x: 10,
    name: 'Gadolinium',
  },
  Ne: {
    type: 'noble',
    y: 2,
    x: 18,
    name: 'Neon',
  },
  B: {
    type: 'metalloid',
    y: 2,
    x: 13,
    name: 'Boron',
  },
  H: {
    type: 'hydrogen',
    y: 1,
    x: 1,
    name: 'Hydrogen',
  },
  Ba: {
    type: 'alkali',
    y: 6,
    x: 2,
    name: 'Barium',
  },
  Mn: {
    type: 'metal',
    y: 4,
    x: 7,
    name: 'Manganese',
  },
  Lr: {
    type: 'metal',
    y: 10,
    x: 17,
    name: 'Lawrencium',
  },
  Lu: {
    type: 'metal',
    y: 9,
    x: 17,
    name: 'Lutetium',
  },
  Os: {
    type: 'metal',
    y: 6,
    x: 8,
    name: 'Osmium',
  },
  Fl: {
    type: 'metal',
    y: 7,
    x: 14,
    name: 'Flerovium',
  },
  P: {
    type: 'nonmetal',
    y: 3,
    x: 15,
    name: 'Phosphorus',
  },
  Be: {
    type: 'alkali',
    y: 2,
    x: 2,
    name: 'Beryllium',
  },
  Ra: {
    type: 'alkali',
    y: 7,
    x: 2,
    name: 'Radium',
  },
  Sm: {
    type: 'metal',
    y: 9,
    x: 8,
    name: 'Samarium',
  },
  Re: {
    type: 'metal',
    y: 6,
    x: 7,
    name: 'Rhenium',
  },
  Cm: {
    type: 'metal',
    y: 10,
    x: 10,
    name: 'Curium',
  },
  Fe: {
    type: 'metal',
    y: 4,
    x: 8,
    name: 'Iron',
  },
  Bi: {
    type: 'metal',
    y: 6,
    x: 15,
    name: 'Bismuth',
  },
  Hs: {
    type: 'metal',
    y: 7,
    x: 8,
    name: 'Hassium',
  },
  Pt: {
    type: 'metal',
    y: 6,
    x: 10,
    name: 'Platinum',
  },
  In: {
    type: 'metal',
    y: 5,
    x: 13,
    name: 'Indium',
  },
  Kr: {
    type: 'noble',
    y: 4,
    x: 18,
    name: 'Krypton',
  },
  Ce: {
    type: 'metal',
    y: 9,
    x: 4,
    name: 'Cerium',
  },
  Ir: {
    type: 'metal',
    y: 6,
    x: 9,
    name: 'Iridium',
  },
  Nh: {
    type: 'metal',
    y: 7,
    x: 13,
    name: 'Nihonium',
  },
  Cd: {
    type: 'metal',
    y: 5,
    x: 12,
    name: 'Cadmium',
  },
  Dy: {
    type: 'metal',
    y: 9,
    x: 12,
    name: 'Dysprosium',
  },
  Te: {
    type: 'metalloid',
    y: 5,
    x: 16,
    name: 'Tellurium',
  },
  Fr: {
    type: 'alkali',
    y: 7,
    x: 1,
    name: 'Francium',
  },
  Nd: {
    type: 'metal',
    y: 9,
    x: 6,
    name: 'Neodymium',
  },
  Nb: {
    type: 'metal',
    y: 5,
    x: 5,
    name: 'Niobium',
  },
  Ac: {
    type: 'metal',
    y: 10,
    x: 3,
    name: 'Actinium',
  },
  V: {
    type: 'metal',
    y: 4,
    x: 5,
    name: 'Vanadium',
  },
  Ar: {
    type: 'noble',
    y: 3,
    x: 18,
    name: 'Argon',
  },
  Ta: {
    type: 'metal',
    y: 6,
    x: 5,
    name: 'Tantalum',
  },
  Rn: {
    type: 'noble',
    y: 6,
    x: 18,
    name: 'Radon',
  },
  F: {
    type: 'halogen',
    y: 2,
    x: 17,
    name: 'Fluorine',
  },
  Db: {
    type: 'metal',
    y: 7,
    x: 5,
    name: 'Dubnium',
  },
  Bh: {
    type: 'metal',
    y: 7,
    x: 7,
    name: 'Bohrium',
  },
  Mg: {
    type: 'alkali',
    y: 3,
    x: 2,
    name: 'Magnesium',
  },
  Ds: {
    type: 'metal',
    y: 7,
    x: 10,
    name: 'Darmstadtium',
  },
  Si: {
    type: 'metalloid',
    y: 3,
    x: 14,
    name: 'Silicon',
  },
  At: {
    type: 'halogen',
    y: 6,
    x: 17,
    name: 'Astatine',
  },
  Tb: {
    type: 'metal',
    y: 9,
    x: 11,
    name: 'Terbium',
  },
  Ts: {
    type: 'halogen',
    y: 7,
    x: 17,
    name: 'Tennessine',
  },
  Ge: {
    type: 'metalloid',
    y: 4,
    x: 14,
    name: 'Germanium',
  },
  W: {
    type: 'metal',
    y: 6,
    x: 6,
    name: 'Tungsten',
  },
  Pm: {
    type: 'metal',
    y: 9,
    x: 7,
    name: 'Promethium',
  },
  Ga: {
    type: 'metal',
    y: 4,
    x: 13,
    name: 'Gallium',
  },
  Er: {
    type: 'metal',
    y: 9,
    x: 14,
    name: 'Erbium',
  },
  Tc: {
    type: 'metal',
    y: 5,
    x: 7,
    name: 'Technetium',
  },
  Rb: {
    type: 'alkali',
    y: 5,
    x: 1,
    name: 'Rubidium',
  },
  Co: {
    type: 'metal',
    y: 4,
    x: 9,
    name: 'Cobalt',
  },
  Xe: {
    type: 'noble',
    y: 5,
    x: 18,
    name: 'Xenon',
  },
  Lv: {
    type: 'metal',
    y: 7,
    x: 16,
    name: 'Livermorium',
  },
  Pb: {
    type: 'metal',
    y: 6,
    x: 14,
    name: 'Lead',
  },
  Eu: {
    type: 'metal',
    y: 9,
    x: 9,
    name: 'Europium',
  },
  S: {
    type: 'nonmetal',
    y: 3,
    x: 16,
    name: 'Sulfur',
  },
  Li: {
    type: 'alkali',
    y: 2,
    x: 1,
    name: 'Lithium',
  },
  Tl: {
    type: 'metal',
    y: 6,
    x: 13,
    name: 'Thallium',
  },
  Cf: {
    type: 'metal',
    y: 10,
    x: 12,
    name: 'Californium',
  },
  Np: {
    type: 'metal',
    y: 10,
    x: 7,
    name: 'Neptunium',
  },
  Zr: {
    type: 'metal',
    y: 5,
    x: 4,
    name: 'Zirconium',
  },
  Og: {
    type: 'noble',
    y: 7,
    x: 18,
    name: 'Oganesson',
  },
  U: {
    type: 'metal',
    y: 10,
    x: 6,
    name: 'Uranium',
  },
  La: {
    type: 'metal',
    y: 9,
    x: 3,
    name: 'Lanthanum',
  },
  K: {
    type: 'alkali',
    y: 4,
    x: 1,
    name: 'Potassium',
  },
  Sc: {
    type: 'metal',
    y: 4,
    x: 3,
    name: 'Scandium',
  },
  Ru: {
    type: 'metal',
    y: 5,
    x: 8,
    name: 'Ruthenium',
  },
  Ti: {
    type: 'metal',
    y: 4,
    x: 4,
    name: 'Titanium',
  },
  Hg: {
    type: 'metal',
    y: 6,
    x: 12,
    name: 'Mercury',
  },
  Rg: {
    type: 'metal',
    y: 7,
    x: 11,
    name: 'Roentgenium',
  },
  Mc: {
    type: 'metal',
    y: 7,
    x: 15,
    name: 'Moscovium',
  },
  Sr: {
    type: 'alkali',
    y: 5,
    x: 2,
    name: 'Strontium',
  },
  Po: {
    type: 'metal',
    y: 6,
    x: 16,
    name: 'Polonium',
  },
  Pu: {
    type: 'metal',
    y: 10,
    x: 8,
    name: 'Plutonium',
  },
  Au: {
    type: 'metal',
    y: 6,
    x: 11,
    name: 'Gold',
  },
  Se: {
    type: 'nonmetal',
    y: 4,
    x: 16,
    name: 'Selenium',
  },
  Fm: {
    type: 'metal',
    y: 10,
    x: 14,
    name: 'Fermium',
  },
  Cn: {
    type: 'metal',
    y: 7,
    x: 12,
    name: 'Copernicium',
  },
  Tm: {
    type: 'metal',
    y: 9,
    x: 15,
    name: 'Thulium',
  },
  Yb: {
    type: 'metal',
    y: 9,
    x: 16,
    name: 'Ytterbium',
  },
  N: {
    type: 'nonmetal',
    y: 2,
    x: 15,
    name: 'Nitrogen',
  },
  Th: {
    type: 'metal',
    y: 10,
    x: 4,
    name: 'Thorium',
  },
  Ni: {
    type: 'metal',
    y: 4,
    x: 10,
    name: 'Nickel',
  },
  Cl: {
    type: 'halogen',
    y: 3,
    x: 17,
    name: 'Chlorine',
  },
  Na: {
    type: 'alkali',
    y: 3,
    x: 1,
    name: 'Sodium',
  },
  Ag: {
    type: 'metal',
    y: 5,
    x: 11,
    name: 'Silver',
  },
  Br: {
    type: 'halogen',
    y: 4,
    x: 17,
    name: 'Bromine',
  },
  Cr: {
    type: 'metal',
    y: 4,
    x: 6,
    name: 'Chromium',
  },
  Cs: {
    type: 'alkali',
    y: 6,
    x: 1,
    name: 'Cesium',
  },
  As: {
    type: 'metalloid',
    y: 4,
    x: 15,
    name: 'Arsenic',
  },
  Pd: {
    type: 'metal',
    y: 5,
    x: 10,
    name: 'Palladium',
  },
  I: {
    type: 'halogen',
    y: 5,
    x: 17,
    name: 'Iodine',
  },
  Mt: {
    type: 'metal',
    y: 7,
    x: 9,
    name: 'Meitnerium',
  },
};
